module.exports = __webpack_public_path__ + "img/cleome.8ee33f40.jpg";